import { $Q, $Qll } from "../utils/query-selector"
import { fetchMainProduct } from "./product-subscriptions";

export const variantOnChange = (component) => {
  const parents = $Qll(component);

  if (parents.length > 1) {
    return parents.forEach(
      parent => {
        iterationOptions(parent)
      }
    );
  }

  return iterationOptions(parents[0])
}

function iterationOptions (parent) {
  return options(parent).forEach(option => {
    option.addEventListener(
      'change',
      () => {

        selectVariant(parent)
        optionsChecked(parent)
      }
    );
  });
}

export function selectVariant(parent, value) {
  let variants = JSON.parse($Q('#variants', parent).value);

  console.log('variants', variants);
 
  const variantFilter = variants.find(
    variant => variant.title === value.trim()
  )

  const modalCart = $Q('.modal-cart'); 

  const modalActive = modalCart.dataset && modalCart.dataset.active;

  const inputs = modalActive === 'true'
    ? $Qll('.main-product__detail [name="id"]', modalCart)
    : $Qll('.main-product__subscriptions-add [name="id"]')

  inputs.forEach(item => {
    item.value = variantFilter.id;
  })

  fetchMainProduct(variantFilter.id, modalActive === 'true' && modalCart);
}

function optionsChecked (parent) {
  let myOptions = [];

  options(parent).forEach(
    option => {
      if(option.type == "radio") {
        if (option.checked == true) {
          myOptions = [...myOptions, option.value]
        }
      } else {
        myOptions = [...myOptions, option.value]
      }
    }
  ) 
  return buildOption(myOptions);
} 

const options = (parent) => $Qll('.js-option', parent);
const buildOption = (options) => {
  return  options.join(' / '); 
}
